import { Search } from "lucide-react";
import { Input } from "@/components/ui/input";
import { STATUS_LABELS } from "./useMarketMap";

const TABS = [["untouched", "Untouched"], ["hunted", "Hunted"], ["parked", "Parked"], ["not_fit", "Not a fit"], ["unverified", "Unverified"], ["pending", "Pending"], ["all", "All"]];
const SORTS = [["fit", "Best fit"], ["size", "Largest"], ["name", "A–Z"], ["recent", "Newest"]];

export const MarketFilters = ({ filters, setFilters, stats, total }) => (
  <div className="flex flex-wrap items-center gap-3 mb-4" data-testid="market-filters">
    <div className="flex flex-wrap gap-1.5">
      {TABS.map(([key, label]) => (
        <button key={key} onClick={() => setFilters((f) => ({ ...f, status: key }))} data-testid={`market-tab-${key}`}
          className={`px-3 py-1.5 rounded-full text-xs border transition-colors ${filters.status === key ? "bg-ism-teal/15 border-ism-teal/40 text-ism-teal" : "border-white/10 text-gray-400 hover:text-white hover:bg-white/5"}`}>
          {label}{stats && key !== "all" ? <span className="ml-1.5 text-gray-500 tabular-nums">{stats[key] ?? 0}</span> : null}
        </button>
      ))}
    </div>
    <div className="flex items-center gap-2 w-full sm:w-auto sm:ml-auto">
      <div className="relative flex-1 sm:flex-none">
        <Search className="h-3.5 w-3.5 text-gray-500 absolute left-2.5 top-1/2 -translate-y-1/2" />
        <Input value={filters.q} onChange={(e) => setFilters((f) => ({ ...f, q: e.target.value }))} placeholder="Search firms, HQ, industry"
          className="h-8 pl-8 w-full sm:w-52 bg-white/5 border-white/10 text-sm" data-testid="market-search-input" />
      </div>
      <select value={filters.sort} onChange={(e) => setFilters((f) => ({ ...f, sort: e.target.value }))} data-testid="market-sort-select"
        className="h-8 rounded-md bg-white/5 border border-white/10 text-xs text-gray-300 px-2">
        {SORTS.map(([k, l]) => <option key={k} value={k} className="bg-black">{l}</option>)}
      </select>
      <span className="text-xs text-gray-500 tabular-nums whitespace-nowrap" data-testid="market-result-count">{total} <span className="hidden sm:inline">{STATUS_LABELS[filters.status]?.toLowerCase() || "firms"}</span></span>
    </div>
  </div>
);
